import blackEnormous from '../../../assets/logos/logo-drogasil-black-enormoous.svg'
import blackHuge from '../../../assets/logos/logo-drogasil-black-huge.svg'
import blackLarge from '../../../assets/logos/logo-drogasil-black-large.svg'
import type { LogoProps } from '../logo.types'

const sizeToImage = {
  large: blackLarge,
  huge: blackHuge,
  enormous: blackEnormous,
}

const TITLE = 'Drogasil Black Logo'

const DrogasilBlack = ({ size, className }: LogoProps) => {
  return (
    <img
      title={TITLE}
      role="img"
      aria-labelledby={TITLE}
      src={sizeToImage[size ?? 'large']}
      alt={TITLE}
      className={className}
    />
  )
}

export default DrogasilBlack
